'use client'
import { useEffect, useState } from 'react'
import SelectFilter from 'components/SelectFilter'
import ImagesCards from 'components/ImagesCards'
import { getONEImagesList, getStrapiImagesList } from 'services/multimedia'
import { dateToString } from 'utils/date'
// import InfiniteScroll from 'components/InfiniteScroll'
import Spin from 'components/Spin'

const thisYear = new Date().getFullYear()

const PhotosList = () => {
  const [loading, setLoading] = useState(false)
  // This started in 2023 & ONE has 2 more years
  const yearFilterList = Array.from(
    {
      length: thisYear - 2023 + 3
    },
    (_, i) => ({
      value: thisYear - i,
      title: thisYear - i
    })
  )
  const [yearFilterSelected, setYearFilterSelected] = useState(thisYear)
  const typeFilterList = [
    {
      value: 'Competició',
      title: 'Competició'
    },
    {
      value: 'Esdeveniments',
      title: 'Esdeveniments'
    },
    {
      value: 'Docència',
      title: 'Docència'
    }
  ]
  const [typeFilterSelected, setTypeFilterSelected] = useState('')
  const [imagesList, setImagesList] = useState([])
  const [imagesFormatted, setImagesFormatted] = useState([])

  const strapiImagesFormat = () => {
    let images = []
    if (imagesList?.data?.length) {
      images = imagesList.data
        .sort((_a, _b) => {
          const a = _a.attributes
          const b = _b.attributes
          return (
            new Date(b.fecha || b.publishedAt) -
            new Date(a.fecha || a.publishedAt)
          )
        })
        .map((_gallery) => {
          const gallery = _gallery.attributes
          return {
            link: `/multimedia/fotos/${gallery.publishedAt.split('-')[0]}/${
              gallery.slug
            }`,
            date: dateToString(gallery.fecha || gallery.publishedAt).withYear,
            name: gallery.titulo,
            image: gallery.portada.data.attributes.formats.medium.url
          }
        })
    }
    setImagesFormatted(images)
  }

  const oneImagesFormat = () => {
    let images = []
    if (imagesList.length) {
      images = imagesList.map((gallery) => {
        return {
          link: `/multimedia/fotos/${gallery.date.split('-')[0]}/${
            gallery.slug
          }`,
          date: dateToString(gallery.date).withYear,
          name: gallery.title,
          image: gallery.ImageGallery
        }
      })
    }
    setImagesFormatted(images)
  }

  const getStrapiImages = async () => {
    setLoading(true)
    const images = await getStrapiImagesList(
      `filters[$and][0][fecha][$gte]=${yearFilterSelected}-01-01&filters[$and][1][fecha][$lte]=${yearFilterSelected}-12-31${
        typeFilterSelected
          ? `&filters[categoria][$eq]=${typeFilterSelected}`
          : ''
      }`
    )
    setImagesList(images)
    setLoading(false)
  }

  const getONEImages = async () => {
    setLoading(true)
    const images = await getONEImagesList(
      `?levelOne=Temporada ${yearFilterSelected}&levelTwo=${typeFilterSelected}&page=1&limit=50`
    )
    setImagesList(images)
    setLoading(false)
  }

  useEffect(() => {
    if (yearFilterSelected < 2023) {
      oneImagesFormat()
    } else {
      strapiImagesFormat()
    }
  }, [imagesList])

  useEffect(() => {
    if (yearFilterSelected < 2023) {
      getONEImages()
    } else {
      getStrapiImages()
    }
  }, [yearFilterSelected, typeFilterSelected])

  useEffect(() => {
    getStrapiImages()
  }, [])

  return (
    <>
      <div className="bg-sec-grey-4 py-14">
        <div className="max-w-7xl mx-auto">
          <h1 className="font-alliance-tight text-blue text-[58px] lg:text-[110px]">
            Galeria de fotos
          </h1>
        </div>
      </div>
      {imagesFormatted && (
        <div className="max-w-7xl mx-auto">
          <div className="lg:flex mt-16 mx-2">
            <SelectFilter
              filters={yearFilterList}
              setSelected={setYearFilterSelected}
              className="lg:w-[275px] lg:ml-3 mt-2 lg:mt-0"
            />
            <SelectFilter
              text="Tots"
              filters={typeFilterList}
              selected={typeFilterSelected}
              setSelected={setTypeFilterSelected}
              disabledFirstOption={false}
              className="lg:w-[200px] lg:ml-3 mt-2 lg:mt-0"
            />
          </div>
          <>
            {loading ? (
              <div className="flex justify-center my-20">
                <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
              </div>
            ) : (
              <>
                <ImagesCards images={imagesFormatted} />
                {/* <InfiniteScroll
                  page={page}
                  setPage={setPage}
                  pageSize={pageSize}
                  loading={loading}
                  totalResults={images.length}
                /> */}
              </>
            )}
          </>
        </div>
      )}
    </>
  )
}

export default PhotosList
